<script>
import bem from '@/utils/bem';
import getPriceWithOrWithoutSale from '@/utils/getPriceWithOrWithoutSale';
import BeforeAfterPrice from '@/components/ux/beforAfterPrice/Before-after-price.vue';
import BigCountInput from '@/components/ux/inputs/BigCountInput.vue';
import ChangeWizardCard from '@/components/modals/Change-wizard-card.vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { mapActions } from 'vuex';

const b = bem('first-card-design');

export default {
  data() {
    return {
      price: 0,
      additionalDiscount: 0,
      show: false,
    };
  },
  props: {
    isFilm: {
      type: Boolean,
      required: true,
    },
    section: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    lastIndex: {
      type: Number,
      required: true,
    },
    cardsOrderUpdate: {
      type: Function,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
    helpCenterList: {
      type: Array,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      deleteWizardCardAction: 'wizards/deleteWizardCard',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    modalToggle(value) {
      this.show = value;
    },
    onDelete() {
      this.deleteWizardCardAction({ id: this.section.id, type: this.productName });
    },
  },
  components: {
    LeftOutlined,
    RightOutlined,
    BigCountInput,
    BeforeAfterPrice,
    ChangeWizardCard,
  },
  mounted() {
    const {
      sales = [],
      quantity = 0,
      description,
      product,
    } = this.section;
    const feetCount = description.substring(0, description.indexOf(' '));
    const {
      price,
      additionalDiscount,
    } = getPriceWithOrWithoutSale({
      sales,
      quantity: quantity / feetCount,
      product,
    });
    this.price = Number(price);
    this.additionalDiscount = Number(additionalDiscount);
  },
};
</script>

<template>
  <div :class="b('', { isFilm })"
    :style="{
      order: section.order,
      backgroundImage: `url(${section.images[0]})`
    }"
  >
    <div :class="b('edit-button')">
      <a-button
          type="primary"
          size="small"
          @click="modalToggle(true)"
      >
        Edit
      </a-button>
    </div>
    <div :class="b('delete-button')">
      <a-popconfirm title="Sure to delete?" @confirm="onDelete">
        <a-button type="primary" size="small" html-type="button" danger>
          Delete
        </a-button>
      </a-popconfirm>
    </div>
    <ChangeWizardCard
        :section="section"
        title="Wizard card"
        :is-new-card="false"
        :products="products"
        :help-center-list="helpCenterList"
        v-model:show="show"
        :product-name="productName"
    />
    <div :class="b('order-buttons')">
      <div :class="b('button', { right: true })" v-if="index > 0">
        <a-button
            type="primary"
            size="small"
            @click="cardsOrderUpdate(index, index - 1)"
        >
          <template #icon>
            <LeftOutlined />
          </template>
        </a-button>
      </div>
      <div
          :class="b('button', { left: true })"
          v-if="index !== lastIndex"
      >
        <a-button
            type="primary"
            size="small"
            @click="cardsOrderUpdate(index, index + 1)"
        >
          <template #icon>
            <RightOutlined />
          </template>
        </a-button>
      </div>
    </div>
    <div :class="b('bottom-block', { isFilm })">
      <div :class="b('bottom-block-title', { isFilm })">{{ section.title }}</div>
      <div
          :class="b('bottom-block-description')"
          v-if="section.description"
      >
        {{section.description}}
      </div>
      <div
        :class="b('bottom-block-description')"
        v-if="section.innerDescription"
      >
        {{section.innerDescription}}
      </div>
      <div :class="b('middle-block-toggler')" v-if="section.product && section.product.isToggle">
        <div :class="b('toggle', { small: true })">
          <div :class="b('toggle-off')" />
          YES
        </div>
      </div>
      <BigCountInput
          v-else
          :className="b('quantity')"
          :inputClass="b('width-input')"
          :btnClassName="b('count-btn')"
          :bemCount='b'
          :withInput="true"
          :mainCounter="true"
          :minSize="true"
      />
      <div :class="b('bottom-block-price')">
        <BeforeAfterPrice
            :textBeforeClassName="b('text-before-price')"
            :textAfterClassName="b('text-after-price')"
            :priceClassName="b('text-price')"
            :priceAfterClassName="b('text-price-after')"
            :price="price"
            :additionalDiscount="additionalDiscount"
            textBefore=""
            :textAfter="section.subTitle"
            :isRow="true"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./firstCardDesign.scss"></style>
